import { decodeStructuredDocument, encodeStructuredDocument, structuredDocumentSchema, type StructureMapping, type StructuredValue } from '../nodes/structured-document.js';
import type { WebsiteBuilderNodeJSON } from '../types.js';

export interface StructuredDocumentEnvelope {
  format: 'adornis.web-editor';
  version: 1;
  projectId: string;
  revision?: string;
  updatedAt: string;
  doc: WebsiteBuilderNodeJSON;
}
export const isStructuredEnvelope = (value: unknown): value is StructuredDocumentEnvelope => {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<StructuredDocumentEnvelope>;
  return candidate.format === 'adornis.web-editor' && candidate.version === 1 && typeof candidate.projectId === 'string' && typeof candidate.updatedAt === 'string' && Boolean(candidate.doc);
};
export const createStructuredEnvelope = (projectId: string, value: StructuredValue, updatedAt: string, revision?: string, mapping?: StructureMapping): StructuredDocumentEnvelope => ({
  format: 'adornis.web-editor', version: 1, projectId, updatedAt, ...(revision ? { revision } : {}),
  doc: encodeStructuredDocument(value, mapping).toJSON() as WebsiteBuilderNodeJSON,
});
export const readStructuredEnvelope = (envelope: StructuredDocumentEnvelope): StructuredValue =>
  decodeStructuredDocument(structuredDocumentSchema.nodeFromJSON(envelope.doc));

export interface MigrationReport {
  projectId: string;
  equivalent: boolean;
  nodeCount: number;
  textCount: number;
}
export const migrateStructuredProject = (projectId: string, value: StructuredValue, updatedAt: string, revision?: string, mapping?: StructureMapping) => {
  const document = createStructuredEnvelope(projectId, value, updatedAt, revision, mapping);
  const restored = readStructuredEnvelope(document);
  let nodeCount = 0; let textCount = 0;
  structuredDocumentSchema.nodeFromJSON(document.doc).descendants(node => { nodeCount++; if (node.isText) textCount += node.text!.length; });
  const report: MigrationReport = { projectId, equivalent: JSON.stringify(restored) === JSON.stringify(value), nodeCount, textCount };
  if (!report.equivalent) throw new Error('Migration parity check failed. Original data must remain active.');
  return { document, report };
};
